import styled from 'styled-components';

import { colors } from '@/globalStyles';

export const InputStyled = styled.input`
  width: 100%;
  padding: 0;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin: 10px 0 0;
  padding: 13px 15px;
  border-radius: 4px;
  background-color: ${colors.white};
  outline: none;
  border: none;

  &:hover {
    border: solid 1px ${colors.whiteSmoke};
  }

  &:focus {
    border: solid 1px ${colors.primary};
  }
`;

export const ModalInputStyled = styled.input`
  width: 100%;
  height: 50px;
  text-align: center;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
  background-color: ${colors.backgroundInput};
  border-bottom: 2px solid ${props => (props.$error ? colors.red : colors.primary)};
  outline: none;
  font-family: Lato;
  font-size: 18px;
  color: ${colors.black};

  &:disabled {
    pointer-events: none;
    filter: grayscale(100%);
    opacity: 0.7;
  }

  &::placeholder {
    color: ${colors.primary};
    font-style: italic;
  }
`;
